import { noteService, planningEngineService } from '@libs/data-access/queries'
import { notifications } from '@libs/ui/ds'
import { useCommonAppTranslation } from '@libs/utils/translations'
import { useMemoSelector } from '@spa/redux/hooks'
import { useDispatch } from 'react-redux'

import { controllersActions } from '../../redux/modules/controllers'
import { getParams } from '../../redux/selectors'

export const useNote = () => {
  const { t } = useCommonAppTranslation()
  const dispatch = useDispatch()
  const params = useMemoSelector(getParams)
  const config = {
    onSuccess: () => {
      planningEngineService.header.invalidateHeader()
      dispatch(controllersActions.planningSilentRefresh(params))
    },
    onError: () => {
      notifications.error({
        message: t('global.genericError')
      })
    }
  }
  const postNoteMutation = noteService.api.usePostNote(config)
  const putNoteMutation = noteService.api.usePutNote(config)
  const deleteNoteMutation = noteService.api.useDeleteNote(config)

  return {
    postNoteMutation,
    putNoteMutation,
    deleteNoteMutation
  }
}
